module.exports = __webpack_public_path__ + "static/event_3-5e96d50d485dc790af06ec12d65495c6.png";